package ru.malygin

import kotlin.String

public object Secret {
  public val VK_API_KEY: String = "4c8c3b3a-68eb-4e32-9220-940bb253e671"

  public val VK_APP_ID_KEY: String = "b129fb38-ce38-440c-995e-f016804cc6c1"

  public val VK_GROUP_ID_KEY: String = "dd653431-c378-4c05-a94a-9aefec2211e0"

  public val VK_TOPIC_ID_KEY: String = "1e084b1b-b9d9-44d9-affb-5cd4212925a5"

  public val JVM_DB_USER_KEY: String = "dafc1332-bc42-4ef6-acf9-6e8ed56b33b1"

  public val JVM_DB_PASSWORD_KEY: String = "da170df7-5c08-4abc-8980-34ec7224ae60"
}
